__turbopack_context__.v({
  "className": "orbitron_4d3c82ad-module__BQJfuW__className",
});
